import React, { useEffect, useRef, useState } from 'react'
import { hideLoader, showLoader } from '../loader';
import { createFormdataValues } from '../../utils/createFormdataValues';
import { apiUrl } from '../../utils/url';
import { toast } from 'react-toastify';
import useDebounce from '../../services/useDebounce';
import plus from '../../assets/img/plus.svg';

const CompanyStep = ({moveNext}) => {
    const [error, setError] = useState([]);
    const [value, setValue] = useState({
        step: 1,
        company_type: "b2b_saas",
        company_domain: null,
    });
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const suggestionRefs = useRef([]); // Stores refs for each suggestion
    const debouncedValue = useDebounce(value?.company_domain, 500);
    const fetchLogoSuggestions = async (domain) => {
        if (!domain) {
            setSuggestions([]);
            setIsFetching(false);
            return;
        }
    
        setIsFetching(true);
        try {
            const response = await fetch(`https://autocomplete.clearbit.com/v1/companies/suggest?query=${domain}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
    
            const data = await response.json();
            setSuggestions(data);
        } catch (error) {
            console.error('Error fetching domain suggestions:', error);
            setSuggestions([]);
            setShowSuggestions(false);
        } finally {
            setIsFetching(false);
        }
    };
    
    const handleChange = (e) => {
        // fetchLogoSuggestions(e.target.value);
        setValue({ ...value, [e.target.name]: e.target.value })
        if (e.target.name == 'company_domain') {
            setSelectedCompany(null);
            if (e.target.value?.length > 0) {
                setShowSuggestions(true);
            }
        }

    };
    useEffect(() => {
        if (debouncedValue) {
            fetchLogoSuggestions(debouncedValue);
        }else {
            setSuggestions([]);
        }
    }, [debouncedValue]);
    useEffect(() => {
        try {
            const state = JSON.parse(localStorage?.backStepValue);
            if (state?.company_type || state?.company_domain) {
                setValue({ ...value, ...state })
            }
        } catch { }
    }, [localStorage?.backStepValue])
    const handleSubmit = (e) => {
        e.preventDefault();
        showLoader();
        setError([]);
        const domainPattern = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!domainPattern.test(value.company_domain)) {
            toast.error('Please enter a valid domain name (e.g., domain.com)');
            hideLoader();
            return;
        }
        const formdata = createFormdataValues(value);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`)
        let errorList = [];
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
        };
            fetch(apiUrl + "/walkthrough", requestOptions)
            .then(async (res) => {
                hideLoader()
                const response = await res?.json();
                if (response?.status_code == 200) {
                    if (response?.status_message) {
                        toast.success(response?.status_message)
                    }
                    localStorage?.setItem('company_logo',response?.data?.company_logo)
                    localStorage?.setItem('handle',response?.data?.handle)
                    localStorage?.setItem('company_description',response?.data?.company_description)
                    moveNext(e, 2)
                    hideLoader()
                }
                else {
                    if (response?.errors?.company_type)
                        response?.errors?.company_type?.map((val) => errorList?.push(val))
                    if (response?.errors?.company_domain)
                        response?.errors?.company_domain?.map((val) => errorList?.push(val))
                    if (response?.errors?.step)
                        response?.errors?.step?.map((val) => errorList?.push(val))
                    if (response?.status_message) toast.error(response?.status_message);
                    setError(errorList)
                }
            }).catch((err) => {
                hideLoader()

            })
        // }

    }
    const handleSuggestionSelect = (suggestion) => {
        const selectedDomain = suggestion?.domain;
        setValue({
            ...value,
            company_domain: selectedDomain,
            company_logo: suggestion?.logo,
            company_name: suggestion?.name,
        });
        setShowSuggestions(false);
    };
      const handleCloseSuggestions = () => {
        setTimeout(() => {
            setShowSuggestions(false);
        }, 500);  
      };
      const scrollToView = (index) => {
        if (suggestionRefs.current[index]) {
            suggestionRefs.current[index].scrollIntoView({
                behavior: 'smooth',
                block: 'nearest', // Keeps the selected item in view
            });
        }
    };
  return (
    <div>
        <div className='step-heading'>Tell us about your company</div>
        <form action="" onSubmit={handleSubmit} className='step-form'>
            <div className='form-group  mt-20px'>
                <label className='step-label'>What kind of company is it?</label>
                <select onChange={handleChange} value={value?.company_type} name="company_type" style={{boxSizing:"border-box"}} className='zaapGlobal-input cursor-pointer h-30px' id="">
                    <option value="b2b_saas">B2B SaaS</option>
                    <option value="b2c_saas">B2C SaaS</option>
                    <option value="e_commerce">E-commerce</option>
                    <option value="agency">Agency</option>
                    <option value="freelancer">Freelancer</option>
                    <option value="other">Other</option>
                </select>
            </div>
            <div className='form-group mt-20px'>
                <label className='step-label'>What’s your company domain?</label>
                {!value?.company_logo &&
                    <input type='text' autoComplete='off' onChange={handleChange} onBlur={handleCloseSuggestions}  onFocus={() => setShowSuggestions(true)} name='company_domain' value={value?.company_domain} className='zaapGlobal-input h-30px '   onInvalid={(e) => e.target.setCustomValidity('Please enter a valid URL, like https://domain.com')} onInput={(e) => e.target.setCustomValidity('')}  placeholder='https://domain.com' onKeyDown={(e) => {
                        if (e.key === "ArrowDown") {
                            e.preventDefault();
                            setSelectedIndex((prev) => {
                                const nextIndex = prev < suggestions.length ? prev + 1 : 0; // Include static option
                                scrollToView(nextIndex); // Scroll the selected item into view
                                return nextIndex;
                            });
                        } else if (e.key === "ArrowUp") {
                            e.preventDefault();
                            setSelectedIndex((prev) => {
                                const nextIndex = prev > 0 ? prev - 1 : suggestions?.length;
                                scrollToView(nextIndex); // Scroll the selected item into view
                                return nextIndex;
                            });
                        } else if (e.key === "Enter") {
                            e.preventDefault();
                            if (selectedIndex >= 0 && suggestions.length > 0) {
                                handleSuggestionSelect(suggestions[selectedIndex]);
                            }else if (selectedIndex === suggestions.length) {
                                handleSuggestionSelect({domain:e.target.value});
                            }
                        }
                    }}/>
                }
                {value?.company_domain && showSuggestions && (
                    <div className="custom-scrollbar shadow mt-1 domains-dropdown">
                        {isFetching ? (
                            <div className="ps-2 fs-12 text-gray font-weight-500">Loading...</div>
                        ) : suggestions.length > 0 ? (
                            <>
                                <div className='ps-2 fs-12 text-gray font-weight-500'>Results</div>
                                {suggestions.map((suggestion,index) => (
                                    <div
                                        key={index}
                                        onClick={() => handleSuggestionSelect(suggestion)}
                                        className={`domains-dropdown-item ${selectedIndex === index ? 'active' : ''}`}
                                    >
                                        {suggestion?.logo && (
                                            <img
                                                src={suggestion?.logo}
                                                alt={`${suggestion?.name} logo`}
                                                width={20}
                                                height={20}
                                                className="mr-3 rounded object-fit-contain"
                                            />
                                        )}
                                        <div className='d-flex justify-content-between align-items-center w-100 gap-3'>
                                            <div className="domains-dropdown-name font-weight-bold fs-14px text-truncate">
                                                {suggestion?.name}
                                            </div>
                                            <div className="text-gray small text-truncate">{suggestion?.domain}</div>
                                        </div>
                                    </div>
                                ))}
                            </>
                        ) : (
                            <div className="ps-2 text-gray fs-12">No results found</div>
                        )}
                        <div ref={(el) => (suggestionRefs.current[suggestions.length] = el)} className={`domains-dropdown-item fs-12  gap-1 ${selectedIndex === suggestions?.length ? 'active' : ''}`} onClick={() => handleSuggestionSelect({domain:value?.company_domain})}>
                            <img className='filter-invert-1' width={9} src={plus} alt="" srcset="" /> Add {value?.company_domain}
                        </div>
                    </div>
                )}
                {value?.company_logo && value?.company_name && value?.company_domain && (
                    <div className="zaapGlobal-input mt-2 d-flex justify-content-between align-items-center w-100 gap-2 py-1" >
                        {value?.company_logo && (
                            <img
                                src={value?.company_logo}
                                alt={`${value?.company_name} logo`}
                                width={20}
                                height={20}
                                className="mr-3 rounded object-fit-contain"
                            />
                        )}
                        <div className='d-flex align-items-center justify-content-between w-100'>
                            <div className="fs-12 domains-dropdown-name font-weight-bold text-truncate">
                                {value?.company_name}
                            </div>
                            <div className="text-gray small text-truncate">{value?.company_domain}</div>
                        </div>
                        <button className="btn btn-icon btn-sm text-gray p-0 fs-12" onClick={() =>
                                setValue({...value, company_domain: value?.company_domain, company_logo: '', company_name: '' })
                            }>
                            ✖
                        </button>
                    </div>
                )}
            </div>
            <button type="submit" name="submit" className="fs-12 mt-20px w-100 shadow-none project-blue-btn ">
                Continue
            </button>
        </form>
    </div>
  )
}

export default CompanyStep